export default __webpack_public_path__ + "static/media/ookiversity-banner.25b561b5.jpeg";